import React, {useEffect, useRef, useState} from 'react'
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import {accessToken} from "./../tokens";
import nflTeams from "./../utils/nflTeams";
import {countries} from "../utils/country-boundaries";
import {europeCountries} from "../utils/europe-countries";


function EuropeMap({locations, setOpenTripModal, onMarkerEvent, setLocation}) {
    mapboxgl.accessToken = accessToken;
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [locationMarkersObj, setLocationMarkersObj] = useState({})

    const getZoom = (newCenterCoordinates = null) => {
        console.log("getting zoom")
        const pixelWidthOfPage = document.getElementById("europe-map-container")?.offsetWidth
        console.log("pizelWidth of page: " + pixelWidthOfPage)
        if (pixelWidthOfPage) {
            const zoomMap = {
                1: 29979.718,
                2: 14989.859,
                3: 7494.929,
                4: 3747.465,
                5: 1873.732,
                6: 936.866,
                7: 468.433,
                8: 234.217
            }
            const latDistanceInMeters = 5000000
            for (let i = 8; i >= 1; i--) {
                const zoomReductionFactor = window.innerWidth < 800 ? 1 : 0.8
                let zoomWidthInMeters = (zoomMap[i] * pixelWidthOfPage * zoomReductionFactor)
                console.log(i, latDistanceInMeters, zoomWidthInMeters)
                if (latDistanceInMeters < zoomWidthInMeters) {
                    const difference = zoomWidthInMeters - latDistanceInMeters
                    let zoomWidthInMetersPreviousZoom = (zoomMap[i + 1] * pixelWidthOfPage * zoomReductionFactor)
                    const differenceBetweenZooms = (difference/zoomWidthInMetersPreviousZoom) * zoomReductionFactor
                    console.log("zooming to: " + i)
                    map.current.zoomTo(i + differenceBetweenZooms  , {duration: 1000, animate: true})
                    return;
                }
            }
        }
    }

    useEffect(() => {
        setTimeout(() => {
            getZoom()
        }, 1000)
    }, [])

    function addListenersToMarker(marker, location) {
        const markerDiv = marker.getElement();
        markerDiv.addEventListener('click', () => {
            onMarkerEvent(location, locationMarkersObj, locations)
        })

    }

    const addMarkersToLocations = (locations, markersObj) => {
        locations?.forEach((activityLocation, index) => {
            if (activityLocation) {
                fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${activityLocation.location}.json?access_token=${accessToken}`)
                    .then(response => response.json())
                    .then(data => {
                        if (data.features) {
                            const coordinates = {
                                lng: data.features[0].center[0],
                                lat: data.features[0].center[1]
                            }
                            const marker = new mapboxgl.Marker({
                                scale: 0.5,
                                color: 'black'
                            })
                                .setLngLat(coordinates)
                                .addTo(map.current);
                            addListenersToMarker(marker, activityLocation.location)
                            markersObj[activityLocation.location] = marker
                        }
                    })
            }
        })
        setLocationMarkersObj(markersObj)
    }


    useEffect(() => {
        if (locations && locations.length) {
            addMarkersToLocations(locations, {})
            if (map.current){
                europeCountries?.forEach(countryObj => {
                    const countryName = countryObj.name
                    const countryInfo = countries.find(countryObj => {
                        return countryObj["cntry_name_en"][0] === countryName
                    })
                        let countryHasBeenVisited = false
                        locations.forEach(location => {
                            if (location.country === countryName) {
                                countryHasBeenVisited = true
                            }
                        })
                        // team.Team.toLowerCase().includes(trip.categoryItem.toLowerCase()
                        map.current.addSource(countryName, {
                            'type': 'geojson',
                            'data': {
                                "type": "FeatureCollection",
                                "features": [
                                    countryInfo?.["geo_shape"]
                                ]
                            }
                        });

                        // const colorArray = ['Red', 'White', 'Blue']
                        //
                        // const randomColor = colorArray[Math.floor(Math.random() * 3)]
                        map.current.addLayer({
                            'id': `${countryName}state-fills`,
                            'type': 'fill',
                            'source': countryName,
                            'layout': {},
                            'paint': {
                                'fill-color': countryHasBeenVisited ? 'white' : '#565656',
                                'fill-opacity': [
                                    'case',
                                    ['boolean', ['feature-state', 'hover'], false],
                                    1,
                                    countryHasBeenVisited ? 0.2 : 0.8
                                ]
                            }
                        });

                        map.current.addLayer({
                            'id': `${countryName}state-borders`,
                            'type': 'line',
                            'source': countryName,
                            'layout': {},
                            'paint': {
                                'line-color': 'black',
                                'line-width': 1
                            }
                        });
                        map.current.on('click', `${countryName}state-fills`, (e) => {
                            if (countryHasBeenVisited) {
                                setLocation(countryName)
                            }
                        });
                })
            }

            // });
        }
    }, [locations, map.current])


    useEffect(() => {
        if (map.current) return;
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [9, 48],
            zoom: 4.2,
        });
        // Data: UN Human Development Index 2017 Europe extract
// Source: https://ourworldindata.org/human-development-index
        const data = [
            {"code": "CUB"},
            {'code': "BHS"},
            {'code': 'MEX', 'hdi': 0},
            {'code': 'CAN', 'hdi': 0}
        ];

        map.current.on('load', () => {
// Add source for country polygons using the Mapbox Countries tileset
// The polygons contain an ISO 3166 alpha-3 code which can be used to for joining the data
// https://docs.mapbox.com/vector-tiles/reference/mapbox-countries-v1
            map.current.addSource('countries', {
                type: 'vector',
                url: 'mapbox://mapbox.country-boundaries-v1'
            });

// Build a GL match expression that defines the color for every vector tile feature
// Use the ISO 3166-1 alpha 3 code as the lookup key for the country shape
            const matchExpression = ['match', ['get', 'iso_3166_1_alpha_3']];

// Calculate color values for each country based on 'hdi' value
            for (const row of data) {
// Convert the range of data values to a suitable color
                const green = row['hdi'] * 255;
                const color = `rgb(255, 255, 255)`;

                matchExpression.push(row['code'], color);
            }

// Last value is the default, used where there is no data
            matchExpression.push('rgba(0, 0, 0, 0)');


// The mapbox.country-boundaries-v1 tileset includes multiple polygons for some
// countries with disputed borders.  The following expression filters the
// map view to show the "US" perspective of borders for disputed countries.
// Other world views are available, for more details, see the documentation
// on the "worldview" feature property at
// https://docs.mapbox.com/data/tilesets/reference/mapbox-countries-v1/#--polygon---worldview-text
            const WORLDVIEW = "US";
            const worldview_filter = ["all", ["==", ["get", "disputed"], "false"], ["any", ["==", "all", ["get", "worldview"]], ["in", WORLDVIEW, ["get", "worldview"]]]];

// Add layer from the vector tile source to create the choropleth
// Insert it below the 'admin-1-boundary-bg' layer in the style
            map.current.addLayer(
                {
                    'id': 'countries-join',
                    'type': 'fill',
                    'source': 'countries',
                    'source-layer': 'country_boundaries',
                    'paint': {
                        'fill-color': matchExpression
                    },
                    'filter': worldview_filter
                },
                'admin-1-boundary-bg'
            );
        });

    });

    setTimeout(() => {
        console.log(map.current?.getZoom())
        console.log(map.current?.getCenter())
    }, 10000)


    return (
        <div id='fullScreenMap'>
            <div ref={mapContainer} className="map-container-fullscreen"/>
        </div>
    );
}

export default EuropeMap;